import config from '../config';

/**
 * Builds the URL for a user's avatar image.
 *
 * The backend at GET /users/get-user-avatar/{cognito_id} returns image bytes
 * (base64 data URI stored in DB), a redirect to a Google profile URL, or 204
 * No Content when no avatar exists. The Image component handles all of these —
 * 204 triggers onError which falls back to initials.
 *
 * The optional updatedAt timestamp acts as a cache-buster (matches web behaviour).
 */
export const buildAvatarUrl = (
  cognitoId: string | null | undefined,
  updatedAt?: string | null,
): string | null => {
  if (!cognitoId) return null;
  const ts = updatedAt ? `?${updatedAt}` : '';
  return `${config.apiGateway.endpoint}/users/get-user-avatar/${cognitoId}${ts}`;
};
